"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
function Step(_a) {
    var visited = _a.visited, selected = _a.selected, label = _a.label, id = _a.id;
    var colorDivider = 'secondary.light';
    var fontWeight = 500;
    if (visited || selected) {
        colorDivider = 'primary.main';
        fontWeight = 600;
    }
    var colorText = 'text.disabled';
    if (visited) {
        colorText = 'text.primary';
    }
    if (selected) {
        colorText = 'primary.main';
    }
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsxs)(system_1.Stack, __assign({ textAlign: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: {
                        color: colorText,
                        fontWeight: fontWeight,
                        '&:hover': {
                            cursor: visited ? 'grab' : 'pointer',
                        },
                    } }, { children: label })), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        bgcolor: colorDivider,
                        borderRadius: 8,
                        height: 8,
                        width: '100%',
                    } })] }), "step-chip-".concat(id)) }));
}
exports.default = Step;
Step.defaultProps = {};
//# sourceMappingURL=Step.js.map